import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const BREAKPOINTS = {
  DESKTOP_BIG_MAX: 999999999,
  DESKTOP_BIG_MIN: 1600,
  DESKTOP_MEDIUM_MAX: 1600,
  DESKTOP_MEDIUM_MIN: 1230,
  DESKTOP_TO_TABLET_MAX: 1230,
  DESKTOP_TO_TABLET_MIN: 800,
  MOBILE_MAX: 800,
  MOBILE_MIN: 0,
};

export const GuidesSectionTitlesWrapper = styled.div`
  text-align: center;
  max-width: 1120px;
  margin: auto;
  position: relative;
  z-index: 1;
  margin-bottom: 50px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 30px;
  }
`;

export const GuidesSectionTitle = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
  margin-top: 80px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    margin-top: 40px;
    font-size: 24px;
    line-height: 36px;
  }
`;

export const GuidesSectionSubtitle = styled.p`
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-top: 6px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    margin-top: 4px;
    font-size: 16px;
  }
`;

// oh my god, this is a nasty workaround for react-multi-carousel
// https://github.com/YIZHUANG/react-multi-carousel/issues/186
export const GuidesSectionSliderWrapper = styled.div`
  margin-left: -10%;
  margin-right: -10%;

  @media (max-width: ${BREAKPOINTS.DESKTOP_TO_TABLET_MIN}px) {
    margin-left: -15%;
    margin-right: -15%;
  }
  @media (max-width: 500px) {
    margin-left: -20%;
    margin-right: -20%;
  }
  @media (max-width: 400px) {
    margin-left: -25%;
    margin-right: -25%;
  }
`;

export const GuidesSectionSliderArrowsWrapper = styled.div`
  max-width: 1120px;
  margin: auto;
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 70px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const GuidesSectionSliderArrow = styled.span`
  background-color: transparent;
  border: 2px solid ${getColor('OLD_GRAY_80')};
  border-radius: 100%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const GuidesSectionSliderArrowImg = styled.img``;
